"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvoInspectorEnv = void 0;
exports.AvoInspectorEnv = {
    Prod: "prod",
    Dev: "dev",
    Staging: "staging",
};
